import { useState, useEffect } from "react";
import { Menu, X, Globe } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";

export default function Header({ onCTAClick }) {
  const { t, lang, toggle } = useLang();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", h);
    return () => window.removeEventListener("scroll", h);
  }, []);

  const links = [
    { id: "services", label: t.nav.services },
    { id: "industries", label: t.nav.industries },
    { id: "methodology", label: t.nav.method },
    { id: "cases", label: lang === "ar" ? "قصص التحوّل" : "Cases" },
    { id: "healthcheck", label: t.nav.healthcheck },
    { id: "contact", label: t.nav.contact },
  ];

  const handleAnchor = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all ${scrolled ? "glass" : "bg-transparent"}`}
    >
      <div className="container-cb flex items-center justify-between py-4">
        <a href="#top" onClick={(e) => { e.preventDefault(); handleAnchor("top"); }} className="flex items-center gap-3" data-testid="brand-logo">
          <div className="w-10 h-10 rounded-lg bg-cb-dark grid place-items-center text-white">
            <span style={{ fontFamily: "Outfit", fontWeight: 700 }}>CB</span>
          </div>
          <div className="leading-tight">
            <div className="text-cb-primary font-semibold" style={{ fontFamily: "Outfit" }}>Capital Bay</div>
            <div className="text-[11px] text-cb-secondary tracking-widest uppercase">Management Consulting</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => handleAnchor(l.id)}
              data-testid={`nav-${l.id}`}
              className="text-sm text-cb-primary/80 hover:text-cb-primary transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            onClick={toggle}
            data-testid="lang-toggle"
            className="flex items-center gap-1.5 px-3 py-2 rounded-full border border-cb-primary/15 text-sm text-cb-primary hover:bg-cb-primary hover:text-white transition-colors"
            aria-label="Toggle language"
          >
            <Globe size={14} />
            <span>{lang === "en" ? "العربية" : "English"}</span>
          </button>
          <button
            onClick={onCTAClick}
            data-testid="header-cta"
            className="hidden md:inline-flex btn-primary px-4 py-2 rounded-full text-sm font-medium"
          >
            {t.nav.cta}
          </button>
          <button
            className="lg:hidden p-2"
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden glass border-t border-cb-primary/5">
          <div className="container-cb py-4 flex flex-col gap-2">
            {links.map((l) => (
              <button
                key={l.id}
                onClick={() => handleAnchor(l.id)}
                data-testid={`mobile-nav-${l.id}`}
                className="text-start py-2 text-cb-primary"
              >
                {l.label}
              </button>
            ))}
            <button onClick={() => { setOpen(false); onCTAClick(); }} className="btn-primary px-4 py-2 rounded-full mt-2" data-testid="mobile-header-cta">
              {t.nav.cta}
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
